import { ca } from '@cian/analytics';

export function trackClick(label: string) {
  ca('event', {
    action: 'complain_open_main_block',
    category: 'card',
    label,
    name: 'oldevent',
  });
}
